import { Outlet } from 'react-router-dom'

const Fisheries = () => {
  return <Outlet />
}

export default Fisheries
